export default "__VITE_ASSET__BomLLqwl__"